function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import DatastudioDatasourceService from '@/apps/data-platform/services/visualization/datastudio_datasource_service';
import { DEFAULT_TPL_FIELDS, METADATA_FILE_FORMAT, BUCKET_DIRECTORY_TYPES, METADATA_IMAGE_FORMAT, ROLES_LIST, PATTERNS_VALIDATION } from '@/js/constants';
import FilesService from '@/apps/data-platform/services/security/files_service';
import tasks from '@/js/tasks';
export default {
  name: 'ReportTabDatasource',
  props: {
    item: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    showButton: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    isChangeRequest: {
      type: String,
      default: ''
    },
    valid: {
      type: Object,
      default: function _default() {
        return {
          kdomain: null,
          ksubdomain: null,
          kbusiness_term: null
        };
      }
    }
  },
  data: function data() {
    return {
      // --- Buscador/listado ---
      q: '',
      idKey: 'dataset_id',
      // usa 'id' si tu endpoint devuelve otra llave
      data_list: [],
      page: 1,
      pageSize: 10,
      selectedTemp: [],
      // --- EXISTENTE ---
      DEFAULT_TPL_FIELDS: DEFAULT_TPL_FIELDS,
      METADATA_FILE_FORMAT: METADATA_FILE_FORMAT,
      METADATA_IMAGE_FORMAT: METADATA_IMAGE_FORMAT,
      dismissSecs: 8,
      dangerMessage: '',
      environ_initial: '',
      inputUploadFile: null,
      domain_table: '',
      files: [],
      currentFile: {},
      PATTERNS_VALIDATION: PATTERNS_VALIDATION,
      kdomain: null,
      ksubdomain: null,
      kbusiness_term: null,
      bt_add: {
        kdomain: null,
        domain_description: '',
        ksubdomain: null,
        subdomain_description: '',
        kbusiness_term: null,
        term_description: '',
        term_definition: '',
        in_report: true
      },
      datasource_add: {
        id: '',
        name: '',
        description: ''
      },
      inputUploadImage: null,
      key_table: 1,
      dsources: [],
      // auxiliar local para lookup rápido por id seleccionado
      _selectedIdSet: new Set()
    };
  },
  computed: _objectSpread(_objectSpread({
    headersTable: function headersTable() {
      // (se mantiene por compatibilidad si lo usas en otro lugar)
      return [{
        value: 'name',
        text: this.$t('my_tasks.tablas_tasks.name')
      }, {
        value: 'description',
        text: this.$t('my_tasks.modals.description')
      }, {
        value: 'action',
        text: this.$t('my_tasks.tablas_tasks.actions')
      }];
    }
  }, mapState('data-platform', ['selectDomain', 'selectSubdomain', 'selectBusinessTerm'])), {}, {
    headersSearch: function headersSearch() {
      return [{
        value: 'dataset',
        text: 'DATASET'
      }, {
        value: 'action',
        text: 'SELECCIONAR',
        align: 'center'
      }];
    },
    filtered: function filtered() {
      var q = (this.q || '').toLowerCase();
      if (!q) return this.data_list;
      return this.data_list.filter(function (it) {
        var name = (it.object_name || it.title || it.name || '').toLowerCase();
        var path = (it.path_name || it.path || '').toLowerCase();
        return name.includes(q) || path.includes(q);
      });
    },
    pages: function pages() {
      return Math.max(1, Math.ceil(this.filtered.length / this.pageSize));
    },
    pagedItems: function pagedItems() {
      var start = (this.page - 1) * this.pageSize;
      return this.filtered.slice(start, start + this.pageSize);
    }
  }),
  created: function created() {
    console.log('created datasource');
    // ⛏️ Sin optional chaining
    this.domain_table = window && window.userInfo ? window.userInfo.domain : null;
    this.environ_initial = this.item['environment'];
    this.files = this.item.files || [];
    if (Array.isArray(this.item.datasources)) this.dsources = this.item.datasources;
    this.reloadList();
  },
  methods: {
    addSelected: function addSelected() {
      var _this = this;
      var vals = Array.isArray(this.selectedTemp) ? this.selectedTemp : [this.selectedTemp];
      vals.forEach(function (val) {
        // Busca por id o por dataset_id (según venga del backend)
        var found = _this.data_list.find(function (it) {
          return it && (it.id === val || it[_this.idKey] === val);
        });
        if (found) _this.onToggle(found, true);
      });

      // opcional: limpia selección del combo
      this.selectedTemp = [];
    },
    // === CARGA DESDE TU ENDPOINT (se mantiene) ===
    reloadList: function reloadList() {
      var _this2 = this;
      var domain = window && window.userInfo ? window.userInfo.domain : null;
      var params = {
        domain: domain,
        pagination: {
          limit: 1000,
          offset: 0
        },
        filters: []
      };
      DatastudioDatasourceService.getDatasets(params).then(function (res) {
        if (res && res.code === 200) {
          _this2.data_list = Array.isArray(res.data) ? res.data : [];
          _this2.page = 1;
          // sincroniza checks con dsources existentes
          _this2.syncChecksWithDsources();
        } else {
          _this2.data_list = [];
        }
      }).catch(function () {
        _this2.data_list = [];
      });
    },
    // === Helpers de mapeo/chequeo ===
    mapToDatasource: function mapToDatasource(it) {
      return {
        id: it.id || '',
        name: it.object_name || it.title || it.name || '',
        description: this.composePath(it),
        conexiones: it.datasources || []
      };
    },
    composePath: function composePath(it) {
      return (it.path_name || it.path || '').replace(/\//g, ' / ');
    },
    isChecked: function isChecked(it) {
      // Marca true si el dataset ya está en dsources (por nombre o por id si existe)
      var name = it.object_name || it.title || it.name || '';
      var byName = this.dsources.some(function (d) {
        return d.name === name;
      });
      var id = it[this.idKey];
      var byId = id != null && this._selectedIdSet.has(id);
      return byName || byId;
    },
    syncChecksWithDsources: function syncChecksWithDsources() {
      var _this3 = this;
      // reconstruye el Set a partir de lo que trae dsources por nombre
      this._selectedIdSet = new Set();
      if (!Array.isArray(this.data_list) || !Array.isArray(this.dsources)) return;
      var nameSet = new Set(this.dsources.map(function (d) {
        return d.name;
      }));
      this.data_list.forEach(function (it) {
        var name = it.object_name || it.title || it.name || '';
        if (nameSet.has(name)) {
          var id = it[_this3.idKey];
          if (id != null) _this3._selectedIdSet.add(id);
        }
      });
    },
    // === Toggle inmediato desde el check ===
    onToggle: function onToggle(it, checked) {
      if (checked) {
        // agregar si no existe
        var d = this.mapToDatasource(it);
        if (!d.name) return;
        var exists = this.dsources.some(function (x) {
          return x.name === d.name;
        });
        if (!exists) {
          this.dsources.push(d);
          this.item.datasources = this.dsources;
          this.$emit('onChangeDatasource');
          var id = it[this.idKey];
          if (id != null) this._selectedIdSet.add(id);
        }
      } else {
        // quitar si existe
        var name = it.object_name || it.title || it.name || '';
        var idx = this.dsources.findIndex(function (x) {
          return x.name === name;
        });
        if (idx >= 0) {
          this.dsources.splice(idx, 1);
          this.item.datasources = this.dsources;
          this.$emit('onChangeDatasource');
        }
        var _id = it[this.idKey];
        if (_id != null) this._selectedIdSet.delete(_id);
      }
      // forzar refresh si tu UI lo requiere
      this.key_table += 1;
    },
    // --- Métodos originales (si los sigues usando en otros flujos) ---
    onRemoveDatasource: function onRemoveDatasource(item) {
      var index = this.dsources.indexOf(item);
      if (index >= 0) this.dsources.splice(index, 1);
      this.key_table += 1;
      this.item.datasources = this.dsources;
      this.$emit('onChangeDatasource');
    },
    onFileChangeImage: function onFileChangeImage(event) {/* … tu lógica previa … */},
    validAddDatasource: function validAddDatasource() {/* … tu lógica previa … */},
    onAddDatasource: function onAddDatasource() {/* … tu lógica previa … */},
    limpiarAdd: function limpiarAdd() {
      this.datasource_add = {
        id: '',
        name: '',
        description: ''
      };
    }
  }
};